import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
    createSlug,
    favouritesUrl,
    formatPrice,
    getLotStatus,
    toEasternArabicNumerals,
    watchlistUrl,
} from "../../../helpers";
import { togglePropertyLike } from "../../../redux/action/sellerAction";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
    handleWatchlistPageAction,
    removeFavourite,
} from "../../../redux/slice/profileSlice";
import { toggleFavouriteStatus } from "../../../redux/slice/buyerSlice";
import { toast } from "react-toastify";
import { toggleBidFavouriteStatus } from "../../../redux/slice/bidSlice";
import { DOMAIN } from "../../../utils/constants";
import { handleDeleteConfirmationModal } from "../../../redux/slice/modalSlice";
import useTranslationHook from "../../hooks/useTranslationHook";
import CardTimer from "../../common/CardTimer";
import { createPortal } from "react-dom";
const DiscoverCard = ({ ele, view, syncData, layout, section = "" }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const modalRef = useRef(null);
    const user = useSelector((state) => state.auth.user);
    const { t } = useTranslationHook();
    let lang = useSelector((state) => state.translation.lang);
    const isMapPropertyModalOpen = useSelector((state) => state.discover.isMapPropertyModalOpen);
    const isClusterPropertyListOpen = useSelector((state) => state.discover.isClusterPropertyListOpen);

    const isFavourite = location.pathname.includes(favouritesUrl);
    const isWatchlist = location.pathname.includes(watchlistUrl);
    const [isLiked, setIsLiked] = useState(ele?.is_favourite || false);
    const [proeprtyCurrentStatus, setProeprtyCurrentStatus] = useState({
        label: "Loading...",
        className: "active",
    });

    // useEffect(() => {
    //     setIsLiked(ele?.is_favourite || false);
    // }, [ele]);

    const submitReaction = () => {
        setIsLiked((prev) => !prev);
        dispatch(
            toggleFavouriteStatus(
                isFavourite
                    ? ele?.property
                    : isWatchlist
                        ? ele?.property_id
                        : ele?.id
            )
        );
        dispatch(
            toggleBidFavouriteStatus(
                isFavourite
                    ? ele?.property
                    : isWatchlist
                        ? ele?.property_id
                        : ele?.id
            )
        );
        const formData = {
            domain: DOMAIN,
            ...(isFavourite && ele?.property
                ? { property: ele?.property }
                : isWatchlist && ele?.property_id
                    ? { property: ele?.property_id }
                    : ele?.id && { property: ele?.id }),
            ...(user?.user_id && { user: Number(user.user_id) }),
        };
        dispatch(togglePropertyLike(formData));
        toast.success(
            t(`${isLiked ? "Removed from" : "Added to"} favourite list`),
            {
                autoClose: 1000,
            }
        );
    };

    const handleReaction = (e) => {
        if (user?.user_id) {
            const newIsLiked = !isLiked;
            if (!newIsLiked)
                new window.bootstrap.Modal(modalRef.current).show();
            else submitReaction();
        } else {
            navigate("/sign-in");
        }
    };

    const handleModalConfirm = () => {
        window.bootstrap.Modal.getInstance(modalRef.current).hide();
        if (isFavourite) dispatch(removeFavourite(ele?.property));
        submitReaction();
    };

    const handleModalCancel = () => {
        window.bootstrap.Modal.getInstance(modalRef.current).hide();
    };

    const slug = createSlug(
        ele?.property || ele?.property_id || ele?.id,
        `${ele?.property_name} ${ele?.country}`
    );

    const isCalendarLayout = layout === "calendar"

    useLayoutEffect(() => {
        if (ele?.property_for === 2) {
            setProeprtyCurrentStatus(getLotStatus(ele?.session_status?.status_id, ele?.lot_status?.status_id, ele?.lot_pause_resume))
        }
    }, [])

    return (
        <>
            {
                view === "grid" ?
                    <li>
                        <Link className="link-shadow"
                            // to={`/${ele?.property_for === 2 && proeprtyCurrentStatus?.label !== "Closed" ? "live-feed" : "property/detail"}/${slug}`}
                            to={`/${"property/detail"}/${slug}`}
                        >
                            <figure>

                                <img
                                    className="slide-fixed"
                                    src={`/img/${isCalendarLayout ? (section === "today" ? "cal-trans-today" : 'cal-trans') : 'trans-3x2'}.png`}
                                    alt=""
                                />
                                <img
                                    className="slide-img"
                                    src={`${process.env.REACT_APP_AZURE_BLOB_URL}${ele?.property_image?.image && ele?.property_image?.bucket_name ? `${ele?.property_image.bucket_name}/${ele?.property_image.image}` : "property_image/default_property.jpg"}`}
                                    alt="Land Plot Image"
                                />

                                <div className="top">
                                    <div className="status-info">
                                        {
                                            !isCalendarLayout && <span className="total-bid">
                                                {t("discover card total bids", {
                                                    totalBids: syncData?.bid_count || 0,
                                                })}
                                            </span>
                                        }
                                        <span className={proeprtyCurrentStatus?.className}>
                                            {t(proeprtyCurrentStatus?.label)}
                                        </span>
                                        {ele?.property_for === 2 && proeprtyCurrentStatus?.label === "Active" ? <span className="live"><em></em> {t("Live Room")}</span> : <></>}
                                        {
                                            ele?.is_featured && <span className="featured-bid"><img className="mr4" src="/img/featured-bid.svg" alt="" />{t("Featured")}</span>
                                        }
                                        {/* visiblity 2 for private auction and 1 for normal auction */}
                                        {
                                            ele?.visibility === 2 ?
                                                <span
                                                    className="private"
                                                >
                                                    <i class="fa-solid fa-user-lock"></i> {t("Private Auction")}
                                                </span> : <></>
                                        }
                                    </div>

                                    <div className="like-btn">
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation();
                                                handleReaction();
                                            }}
                                        >
                                            <img
                                                src={`/img/${isLiked ? "heart-icon-r" : "heart-icon"}.svg`}
                                                alt=""
                                            />
                                        </button>
                                    </div>
                                    {isWatchlist && (
                                        <div className="like-btn">
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    e.stopPropagation();
                                                    dispatch(
                                                        handleDeleteConfirmationModal(
                                                            true
                                                        )
                                                    );
                                                    dispatch(
                                                        handleWatchlistPageAction({
                                                            selectedProperty:
                                                                ele?.property_id,
                                                        })
                                                    );
                                                }}
                                            >
                                                <img
                                                    src="/img/delete-icon.svg"
                                                    alt="Delete Icon"
                                                />
                                            </button>
                                        </div>
                                    )}

                                </div>
                                {/* {
                                    isCalendarLayout &&
                                    <div className="middle">
                                        <h6>
                                            <Link to={`/property/detail/${slug}`}>
                                                {lang === "en"
                                                    ? ele?.property_name
                                                    : ele?.property_name_ar || ""}
                                            </Link>
                                        </h6>
                                    </div>
                                } */}
                                <div className="bottom">
                                    <div className="bid">
                                        {isCalendarLayout && <small>
                                            {lang === "en"
                                                ? ele?.property_name
                                                : ele?.property_name_ar || ""
                                            }
                                        </small>}
                                        {proeprtyCurrentStatus?.label !== "Closed" && (
                                            <div className="high-bid">
                                                {
                                                    !isCalendarLayout && <small>
                                                        {syncData?.bid_count
                                                            ? t("Highest Bid")
                                                            : t("Starting Price")}
                                                    </small>
                                                }
                                                <h6>
                                                    {syncData
                                                        ? t("Amount", {
                                                            amount: `${formatPrice(
                                                                syncData?.bid_count
                                                                    ? syncData?.high_bid_amt
                                                                    : syncData?.start_price,
                                                                lang
                                                            )}`,
                                                        })
                                                        : t("Loading...")}
                                                </h6>
                                            </div>
                                        )}
                                    </div>


                                    {/* {proeprtyCurrentStatus?.label !== "Closed" && (
                                        <div className="high-bid">
                                            {
                                                !isCalendarLayout && <small>
                                                    {syncData?.bid_count
                                                        ? t("Highest Bid")
                                                        : t("Starting Price")}
                                                </small>
                                            }
                                            <h6>
                                                {syncData
                                                    ? t("Amount", {
                                                        amount: `${formatPrice(
                                                            syncData?.bid_count
                                                                ? syncData?.high_bid_amt
                                                                : syncData?.start_price,
                                                            lang
                                                        )}`,
                                                    })
                                                    : t("Loading...")}
                                            </h6>
                                        </div>
                                    )} */}
                                    {syncData && ele?.property_for !== 2 && (
                                        <CardTimer
                                            view={view}
                                            data={syncData}
                                            layout={layout}
                                            onStatusChange={setProeprtyCurrentStatus}
                                        />
                                    )}
                                </div>
                            </figure>
                        </Link>

                        {
                            !isCalendarLayout && <figcaption>
                                <h6>
                                    <Link to={`/property/detail/${slug}`}>
                                        {lang === "en"
                                            ? ele?.property_name
                                            : ele?.property_name_ar || ""}
                                    </Link>
                                </h6>
                                <div className="location">
                                    <span className="map-icon">
                                        <img src="/img/map-icon.svg" alt="" />
                                    </span>{" "}
                                    {`${t(ele?.state_name)} - ${t(lang === "en" ? ele?.community : ele?.community_ar || "")}`}
                                </div>
                                <div className="deposit-text">
                                    {t("Deposit")}:{" "}
                                    <span>
                                        {t("Amount", {
                                            amount: `${formatPrice(ele?.deposit_amount, lang)}`,
                                        })}
                                    </span>
                                </div>
                            </figcaption>
                        }
                    </li>
                    : view === "list" ? <li>
                        <div className="dis-left">
                            <Link className="link-shadow"
                                to={`/${ele?.property_for === 2 && proeprtyCurrentStatus?.label !== "Closed" ? "live-feed" : "property/detail"}/${slug}`}
                            >
                                <figure>
                                    <img
                                        className="slide-fixed"
                                        src="/img/trans-3x2.png"
                                        alt=""
                                    />
                                    <img
                                        className="slide-img"
                                        src={`${process.env.REACT_APP_AZURE_BLOB_URL}${ele?.property_image?.image && ele?.property_image?.bucket_name ? `${ele?.property_image.bucket_name}/${ele?.property_image.image}` : "property_image/default_property.jpg"}`}
                                        alt="Land Plot Image"
                                    />
                                </figure>
                            </Link>
                            <figcaption>
                                <div className="top">
                                    <h6>
                                        <Link to={`/property/detail/${slug}`}>
                                            {lang === "en"
                                                ? ele?.property_name
                                                : ele?.property_name_ar || ""}
                                        </Link>
                                    </h6>
                                    <div className="status-info">
                                        {/* <span className="total-bid">
                                            {t("discover card total bids", {
                                                totalBids: syncData?.bid_count || 0,
                                            })}
                                        </span> */}
                                        {
                                            ele?.property_for === 2 && proeprtyCurrentStatus?.label !== "Closed" &&
                                            <span className="danger">
                                                <em></em>&#9679; {t("Live")}
                                            </span>
                                        }

                                        <span className={proeprtyCurrentStatus?.className}>
                                            {t(proeprtyCurrentStatus?.label)}
                                        </span>
                                        {
                                            ele?.is_featured && <span className="featured-bid"><img className="mr4" src="/img/featured-bid.svg" alt="" />{t("Featured")}</span>
                                        }
                                    </div>
                                </div>
                                <div className="location">
                                    <span className="map-icon">
                                        <img src="/img/map-icon.svg" alt="" />
                                    </span>{" "}
                                    {`${t(ele?.state_name)} - ${t(lang === "en" ? ele?.community : ele?.community_ar || "")}`}
                                </div>
                                <div className="types">
                                    <ul>
                                        <li>
                                            <img
                                                src="/img/ruler-icon.svg"
                                                alt=""
                                            />{" "}
                                            {t("Square Feet", {
                                                squareFeet: ele?.square_footage || 0,
                                            })}
                                        </li>
                                        <li>
                                            <img
                                                src="/img/bed-icon.svg"
                                                alt=""
                                            />{" "}
                                            {ele?.beds === "studio"
                                                ? t("Studio")
                                                : t("Number Of Bedrooms", {
                                                    beds: toEasternArabicNumerals(
                                                        ele?.beds?.slice(0, 2).trim(),
                                                        lang
                                                    ),
                                                })}
                                        </li>
                                        <li>
                                            <img
                                                src="/img/bath-icon.svg"
                                                alt=""
                                            />{" "}
                                            {t("Number Of Bathrooms", {
                                                baths: ele?.baths,
                                            })}
                                        </li>
                                    </ul>
                                </div>
                                {/* <div className="deposit-text">
                                    {t("Deposit")}:{" "}
                                    <span>
                                        {t("Amount", {
                                            amount: `${formatPrice(ele?.deposit_amount, lang)}`,
                                        })}
                                    </span>
                                </div> */}
                            </figcaption>
                        </div>
                        <div className="dis-right">
                            <div className="dis-right-right">
                                {syncData && ele?.property_for !== 2 && (
                                    <CardTimer
                                        useLongLabel
                                        data={syncData}
                                        onStatusChange={setProeprtyCurrentStatus}
                                    />
                                )}
                                {proeprtyCurrentStatus?.label !== "Closed" && (
                                    <div className="high-bid">
                                        <div className="">
                                            <small>
                                                {syncData?.bid_count
                                                    ? t("Highest Bid")
                                                    : t("Starting Price")}
                                            </small>
                                            <h6>
                                                {syncData
                                                    ? t("Amount", {
                                                        amount: `${formatPrice(
                                                            syncData?.bid_count
                                                                ? syncData?.high_bid_amt
                                                                : syncData?.start_price,
                                                            lang
                                                        )}`,
                                                    })
                                                    : t("Loading...")}
                                            </h6>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </li> : isClusterPropertyListOpen ?
                        <li onClick={() => navigate(`/${ele?.property_for === 2 && proeprtyCurrentStatus?.label !== "Closed" ? "live-feed" : "property/detail"}/${slug}`)}>
                            <div className="link-shadow">
                                <figure>
                                    <img
                                        className="slide-fixed"
                                        src="/img/map-trans.png"
                                        alt=""
                                    />
                                    <img
                                        className="slide-img"
                                        src={`${process.env.REACT_APP_AZURE_BLOB_URL}${ele?.property_image?.image && ele?.property_image?.bucket_name ? `${ele?.property_image.bucket_name}/${ele?.property_image.image}` : "property_image/default_property.jpg"}`}
                                        alt="Land Plot Image"
                                    />
                                </figure>
                            </div>
                            <figcaption>
                                <div className="top">
                                    <h6>
                                        <Link to={`/property/detail/${slug}`}>
                                            {lang === "en"
                                                ? ele?.property_name
                                                : ele?.property_name_ar || ""}
                                        </Link>
                                    </h6>
                                    <div className="status-info">
                                        <span className="total-bid">
                                            {t("discover card total bids", {
                                                totalBids: syncData?.bid_count || 0,
                                            })}
                                        </span>
                                        <span className={proeprtyCurrentStatus?.className}>
                                            {t(proeprtyCurrentStatus?.label)}
                                        </span>
                                    </div>
                                </div>
                                <div className="deposit-text">
                                    {t("Deposit")}:{" "}
                                    <span>
                                        {t("Amount", {
                                            amount: `${formatPrice(ele?.deposit_amount, lang)}`,
                                        })}
                                    </span>
                                </div>
                                <div className="bottom">

                                    {syncData && ele?.property_for !== 2 && (
                                        <CardTimer
                                            useLongLabel
                                            data={syncData}
                                            onStatusChange={setProeprtyCurrentStatus}
                                        />
                                    )}
                                    {proeprtyCurrentStatus?.label !== "Closed" && (
                                        <div className="high-bid">
                                            <small>
                                                {syncData?.bid_count
                                                    ? t("Highest Bid")
                                                    : t("Starting Price")}
                                            </small>
                                            <h6>
                                                {syncData
                                                    ? t("Amount", {
                                                        amount: `${formatPrice(
                                                            syncData?.bid_count
                                                                ? syncData?.high_bid_amt
                                                                : syncData?.start_price,
                                                            lang
                                                        )}`,
                                                    })
                                                    : t("Loading...")}
                                            </h6>
                                        </div>
                                    )}
                                </div>
                                <div className="location">
                                    <span className="map-icon">
                                        <img src="/img/map-icon.svg" alt="" />
                                    </span>{" "}
                                    {`${t(ele?.state_name)} - ${t(lang === "en" ? ele?.community : ele?.community_ar || "")}`}
                                </div>
                            </figcaption>
                        </li>
                        : null
            }

            {
                createPortal(<div className="modal fade" ref={modalRef} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title">
                                    {t("Remove from favourite?")}
                                </h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p className="mb0 sky-text">
                                    {t(
                                        "Are you sure about removing it from your favourite collections?"
                                    )}
                                </p>
                            </div>
                            <div className="d-flex">
                                <button
                                    type="button"
                                    className="btn btn-sky btn-md width50"
                                    data-bs-dismiss="modal"
                                    onClick={handleModalCancel}
                                >
                                    {t("Cancel")}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-md width50"
                                    onClick={handleModalConfirm}
                                >
                                    {t("Remove")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>, document.getElementById("root"))
            }
        </>
    );
};

export default React.memo(DiscoverCard);
